
export const CHART_SERIES_COLORS = {
  income: '#38cc65',
  expenses: '#f0383b',
  net: '#006fff',
  savingsRate: '#a354e3',
  unassigned: '#808893',
} as const;

export const CHART_SERIES_TEXT_COLORS = {
  income: '#258341',
  expenses: '#9c2628',
  net: '#0058cc',
  savingsRate: '#683592',
  unassigned: '#50565e',
} as const;

export const CHART_COLORS = [
  '#006fff',
  '#38cc65',
  '#f5a524',
  '#a354e3',
  '#44c6fd',
  '#afd322',
  '#f0383b',
  '#003d9e',
  '#ffdd1a',
  '#0058cc',
  '#258341',
  '#808893',
] as const;

export const CHART_CHROME = {
  splitLine: '#21232712',
  areaFill: '#21232714',
  label: '#50565e',
  surface: '#ffffff',
  tooltipBg: '#383838',
  tooltipText: '#fafafa',
} as const;

export const CHART_HEATMAP_RAMP = ['#e6f1ff', '#006fff'] as const;

export const CHART_PRIMARY = '#006fff';

export const CHART_MARKER = '#50565e';
